import { findSimilarOSAcquisitionStudent } from '@chancenwerk/master-data-management/users/api/findSimilarOSAcquisitionStudent.js';
import { removeOSAcquisitionTagStudent } from '@chancenwerk/master-data-management/users/api/removeOSAcquisitionTag.js';
import { sendRelevantChangeNotificationEmail } from '@chancenwerk/master-data-management/users/api/sendIntensiveCourseStudentChangedEmail.js';
import { setSavedCampusSections as setSavedCampusSectionsMut } from '@chancenwerk/master-data-management/users/api/setSavedCampusSections.js';

export namespace StudentAPI {
  export const findSimilarOSAcquisition = findSimilarOSAcquisitionStudent;
  export const removeOSAcquisitionTag = removeOSAcquisitionTagStudent;
  export const setSavedCampusSections = setSavedCampusSectionsMut;
  export const sendIntensiveCourseStudentChanged = sendRelevantChangeNotificationEmail;
}
